import React, { Suspense } from "react";
import PrivateRoute from "./zoopath/constants/PrivateRoute";

const LabWeb = React.lazy(() => import("./lapweb/pages/LabLayout"));
const LabHome = React.lazy(() => import("./lapweb/pages/LabHome"));
const LabTools = React.lazy(() => import("./lapweb/pages/LabTools"));
const LabPublication = React.lazy(() => import("./lapweb/pages/LabPublication"));
const LabGallery = React.lazy(() => import("./lapweb/pages/LabGallery"));


const Login = React.lazy(() => import("./zoopath/pages/LoginPage"));
const Zoopath = React.lazy(() => import("./zoopath/pages/ZooLayout"));
const ZooHome = React.lazy(() => import("./zoopath/pages/ZooHome"));
const ZooFaqs = React.lazy(() => import("./zoopath/pages/ZooFaqs"));
const ZooTerms = React.lazy(() => import("./zoopath/pages/ZooTerms"));
const ZooContact = React.lazy(() => import("./zoopath/pages/ZooContact"));
const ZooAbout = React.lazy(() => import("./zoopath/pages/ZooAbout"));

const PathogenResult = React.lazy(() =>
  import("./zoopath/pages/PathogenResult")
);

export const routesConfig = [
  {
    path: "/",
    component: LabWeb,
    children: [
      { index: true, component: LabHome },
      { path: "tools", component: LabTools},
      { path: "publications", component: LabPublication},
      { path: "teams", component:LabGallery},
    ],

  },

  {
    path: "zoopath",
    component: Zoopath,
    children: [
      { index: true, component: ZooHome },
       { path: "login", component: Login },

       { path: "pathogen_result", component: () => (
          <PrivateRoute>
            < PathogenResult />
          </PrivateRoute>
        ),
      },
  { path: "faqs", component: ZooFaqs },
   { path: "terms", component: ZooTerms },
  { path: "contact", component: ZooContact },
   { path: "about", component: ZooAbout },


      // { path: "pathogen_result", 
      //   component: PathogenResult },
    
    ],
  },
];

